import React from 'react'
import PropTypes from 'prop-types'
import { useAttachment } from '../contexts/AttachmentContext'
import {
  extractAttachmentMetadata
} from '../utils/attachmentUtils'
import FlexRow from '../../../../components/molecules/FlexRow'
import FlexColumn from '../../../../components/molecules/FlexColumn'
import AttachmentButton from './AttachmentButton'

export default function MessageAttachments ({ message }) {
  const { openAttachment } = useAttachment()

  // Extract all attachments from the message
  const attachments = extractAttachmentMetadata(message)

  if (!attachments || attachments.length === 0) {
    return null
  }

  return (
    <FlexColumn className='mt-3'>
      <FlexRow className='gap-xl flex-wrap mt-2'>
        {attachments.map((attachment, index) => (
          <AttachmentButton
            key={attachment.attachmentId || index}
            onOpen={() => openAttachment(attachment)}
            attachment={attachment}
          />
        ))}
      </FlexRow>
    </FlexColumn>
  )
}

MessageAttachments.propTypes = {
  message: PropTypes.object.isRequired
}
